import React, { useEffect, useState } from 'react';
import './MainSection.scss';

const MainSection = React.forwardRef((props, ref) => {
  const [isHalfScreen, setIsHalfScreen] = useState(false);

  useEffect(() => {
    const handleMouseMove = (e) => {
      const moveX = (e.clientX - window.innerWidth / 2) * -0.005;
      const moveY = (e.clientY - window.innerHeight / 2) * 0.01;
      document.documentElement.style.setProperty('--move-x', `${moveX}deg`);
      document.documentElement.style.setProperty('--move-y', `${moveY}deg`);
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 568) {
        setIsHalfScreen(false);
      } else {
        setIsHalfScreen(true);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
      <section ref={ref} className="section section--landing layers">
        <div className="layers__container">
          <div className="layers__item layer-1" />
          <div className="layers__item layer-2" />
          <div className="layers__item layer-3">
            <div className="overlay">
              {!isHalfScreen ? (
                  <table className="body how-to">
                    <tbody>
                    <tr>
                      <td></td>
                      <td className="animation-1 circle-animation-1" style={{ opacity: 0 }}>automation</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td className="animation-2 circle-animation-2" style={{ opacity: 0 }}>website</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td className="animation-3">Experience</td>
                      <td className="animation-4 circle-animation-3" style={{ opacity: 0 }}>magic</td>
                      <td className="animation-5">Insight</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td className="animation-6 circle-animation-4" style={{ opacity: 0 }}>app</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td className="animation-7 circle-animation-5" style={{ opacity: 0 }}>product</td>
                      <td></td>
                    </tr>
                    </tbody>
                  </table>
              ) : (
                  <div className="mobile-words-container">
                    <div className="word-top">Experience</div>
                    <div className="mobile-words-middle">
                      <span style={{ '--animation-order': 1 }} className="circle-mobile-animation">automation</span>
                      <span style={{ '--animation-order': 2 }} className="circle-mobile-animation">website</span>
                      <span style={{ '--animation-order': 3 }} className="circle-mobile-animation">magic</span>
                      <span style={{ '--animation-order': 4 }} className="circle-mobile-animation">app</span>
                      <span style={{ '--animation-order': 5 }} className="circle-mobile-animation">product</span>
                    </div>
                    <div className="word-bottom">Insight</div>
                  </div>
              )}
              <div className="main-info">
                <div className="short-description">
                  At Kanzu we develop job-perfect IT projects that meet both the needs and the eye
                </div>
                <div className="project-btn">
                  <a href="#contact" type="button">Start a project</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
  );
});

export default MainSection;